<template>
  <Transition
    enter-active-class="transition duration-300 ease-out"
    enter-from-class="transform translate-y-2 opacity-0"
    enter-to-class="transform translate-y-0 opacity-100"
    leave-active-class="transition duration-200 ease-in"
    leave-from-class="transform translate-y-0 opacity-100"
    leave-to-class="transform translate-y-2 opacity-0">
    <div
      v-if="showHeatMap"
      class="absolute bottom-10 left-10 z-50 rounded-lg bg-white p-4 shadow-lg dark:bg-slate-800">
      <h3 class="mb-2 text-sm font-semibold text-gray-700 dark:text-gray-300">
        Flow Traffic Heat Map
      </h3>
      
      <div class="flex items-center gap-2">
        <span class="text-xs text-gray-600 dark:text-gray-400">Low</span>
        <div
          class="h-6 w-32 rounded"
          :style="{
            background: 'linear-gradient(to right, hsl(240, 50%, 90%), hsl(180, 75%, 70%), hsl(120, 100%, 50%), hsl(60, 100%, 50%), hsl(0, 100%, 50%))'
          }" />
        <span class="text-xs text-gray-600 dark:text-gray-400">High</span>
      </div>
      
      <div class="mt-2 text-xs text-gray-500 dark:text-gray-400">
        Node colors indicate relative visitor traffic
      </div>
      
      <div
        v-if="maxVisitorCount"
        class="mt-1 text-xs text-gray-500 dark:text-gray-400">
        Max: {{ maxVisitorCount.toLocaleString() }} visitors
      </div>
    </div>
  </Transition>
</template>

<script setup lang="ts">
const flowBuilderStore = useFlowBuilderStore()
const { showHeatMap } = storeToRefs(flowBuilderStore)

const props = defineProps<{
  maxVisitorCount?: number
}>()
</script>